import ReactStars from 'react-stars'
import styled from 'styled-components'

export const ReviewItem = styled.div`
  border: solid 1px var(--color-primary);
  background-color: rgba(5, 90, 96, 0.1);
  border-radius: 2px;
  padding: 15px;
`
export const TitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
`
export const ReviewTitle = styled.div`
  font-weight: 600;
  font-size: 14px;
  line-height: 21px;
  color: var(--text-heading);
  width: 50%;
  text-align: left;
`
export const ReviewStars = styled.div`
  float: right;
  width: 50%;
  text-align: right;

  & div {
    float: right;
  }
`
export const DescriptionReview = styled.div`
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  height: 4.4rem;
  overflow-wrap: break-word;
  font-size: 14px;
  line-height: 21px;
  text-align: left;
  vertical-align: top;
  opacity: 80%;
  color: var(--text-body);
`

export default function AppComments({ item, id }) {
  return (
    <ReviewItem>
      <TitleContainer>
        <ReviewTitle>{item?.userName}</ReviewTitle>
        <ReviewStars>
          <ReactStars
            count={5}
            size={14}
            color2={'var(--color-warning)'}
            value={item?.rating}
            half={false}
            edit={false}
          />
        </ReviewStars>
      </TitleContainer>
      <DescriptionReview id={id}>{item?.appReview}</DescriptionReview>
    </ReviewItem>
  )
}
